import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class WindowVisibilityService {
  private isWindowVisible = new BehaviorSubject<boolean>(true);

  constructor() {
    this.listenForVisibilityChange();
  }

  private listenForVisibilityChange() {
    document.addEventListener('visibilitychange', () => {
      this.isWindowVisible.next(!document.hidden);
    });
  }

  get windowVisibility$() {
    return this.isWindowVisible.asObservable();
  }
}
